module.exports = __webpack_public_path__ + "static/media/CheckGray.ab191a39.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/InfoBox/CheckGray.svg
 ** module id = 1315
 ** module chunks = 0
 **/